/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  $('.accordian').toggle();

  /*$(".iwish-backdrop").bind( "click", function() {
      console.log("Hello");
      window.cart.getCart();
  });

  $(".iwish-backdrop").trigger( "click" );  */

  $('.sliderule__wrapper').on('click', function(e) {
    console.log($(this));
    $(this).find('.accordian').toggle('slow');
  });

  $('.newsletter-open').on('click', function(e) {
    console.log("nl");
    $('.newsletter-toggle').removeClass('hidden');
  });

  $('.close-nl').on('click', function(e) {
    console.log("nl");
    $('.newsletter-toggle').addClass('hidden');
  });

   // 🔄 Rotating Placeholder START
  var rotatingPlaceholders = [
    'Earrings',
    'Necklaces',
    'Bracelets',
    'Rings',
    'Bangles',
    'Accessories'
  ];

  var searchInput = document.getElementById('result-q');
  var placeholderIndex = 0;

  if (searchInput) {
    function updatePlaceholder() {
      searchInput.setAttribute('placeholder', 'Search for "' + rotatingPlaceholders[placeholderIndex] + '"');
      placeholderIndex = (placeholderIndex + 1) % rotatingPlaceholders.length;
    }

    updatePlaceholder(); // Initial call
    setInterval(updatePlaceholder, 3000); // Change every 3 seconds

    // Optional: Change color on focus/blur
    searchInput.style.color = 'gray';
    searchInput.addEventListener('focus', function() {
      searchInput.style.color = 'black';
    });

    searchInput.addEventListener('blur', function() {
      if (searchInput.value === '') {
        searchInput.style.color = 'gray';
      }
    });
  }
  // 🔄 Rotating Placeholder END


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
